import React, { Component, PropTypes } from 'react';
import { Modal, Alert, Button } from 'antd';


import './ModalMessage.css'


export default class ModalMessage extends Component {

  render() {
    return (
      <div>
        <Modal
          visible={ this.props.visible }
          footer={ null }
          closable={ false }
        >
          <Alert message={ this.props.message }
                 type={this.props.type}/>
          <Button onClick={ this.props.exit }>Close</Button>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/modal-message/ModalMessage.jsx